	import klarna from './klarna.js';
	import _hub from "../scripts/_hub";
	import api from "../scripts/_api"
	import paypal from "./paypal.js"
	import moment from 'moment';
	import {
		EventBus
	} from "../scripts/_eventBus.js";

	export default {
		mixins: [klarna, paypal],
		data() {
			return {
				isNewPayment: true
			}
		},
		computed: {
			paymentMethods() {
				var methods = [];
				var channelMethods = this.Channel.Payment.Methods;

				if (this.isNewPayment) {
					channelMethods = this.Channel.Payment.Sets.filter(x => x.IsActive).map(x => x.Method.Name);
				}

				channelMethods.forEach(element => {
					if (element.toLowerCase() === "paypal") methods.push({
						text: "Paypal",
						image: this.paypalImage,
						value: "Paypal",
						isSelected: this.Reservation.Payment.Method === "Paypal"
					});
					if (element === "Sepa") methods.push({
						text: this.T("Direct_debit"),
						icon: "account_balance",
						value: "Sepa",
						isSelected: this.Reservation.Payment.Method === "Sepa"
					});
					if (element === "CreditCard") methods.push({
						text: this.T("CreditCard"),
						icon: "credit_card",
						value: "CreditCard",
						isSelected: this.Reservation.Payment.Method === "CreditCard"
					});
					if (element === "Cash") methods.push({
						text: this.T("OneTicketing_pay_cash"),
						icon: "store",
						value: "Cash",
						isSelected: this.Reservation.Payment.Method === "Cash"
					});
					if (element === "Klarna") methods.push({
						text: "Klarna",
						image: this.klarnaImage,
						imageClasses: "h-18",
						value: "Klarna",
						isSelected: this.Reservation.Payment.Method === "Klarna"
					});
				});
				return methods;
			},
		},
		methods: {
			getProvider(method) {
				var found = this.Channel.Payment && this.Channel.Payment.Sets && this.Channel.Payment.Sets.find(x => x.Method.Name.toLowerCase() == method.toLowerCase()) || null;
				if (found && found.Provider && found.Provider.Name) return found.Provider.Name;

				return null;
			},
			hasPaymentMethod(method) {
				return this.paymentMethods.some((x) => x.value.toLowerCase() == method.toLowerCase());
			},
			preauth(reservation) {
				if (!this.isNewPayment && reservation.Payment.Method === "CreditCard") {
					return this.loadFirstCashUrl();
				}

				//
				delete reservation._Link;
				delete reservation._id;
				delete reservation._uuid;
				delete reservation._Created;

				//
				reservation._oid = this.Channel._oid;
				if (reservation.Channel) reservation.Channel._uuid = this.Channel._uuid;
				else reservation.Channel = { _uuid: this.Channel._uuid };
				reservation.Status = "PaymentPending";
				reservation._Payment = {
					...reservation._Payment,
					PrePayments: [{
						Value: this.totalSum,
						ValueType: "Absolute",
						Deadline: moment().toISOString()
					}],
					Method: reservation.Payment.Method.toLowerCase() === "paypal" ? "PayPal" : reservation.Payment.Method,
					Provider: this.getProvider(reservation.Payment.Method),
					ChannelURL: process.env.VUE_APP_HOST_TOCC
				};
				
				if (reservation.Mode === "Ticket") reservation.Mode = "Shifts";

				//
				return new Promise((resolve, reject) => {
					api.post("payment/Entity.Ticketing.Reservation/preauth", reservation, result => {
						if (result.Meta && result.Meta.IsValid && result.Value) {
							this.setResponse(result.Value);
							resolve();
						} else {
							reject(result);
						}
					});
				})
			},
			loadFirstCashUrl() {
				return new Promise((resolve, reject) => {
					var command = "/settings/firstCashUrl?amount=" + this.totalSum;
					this.apiRequest(command, null, "GET", result => {
						if (result.Meta && result.Meta.IsValid) {
							resolve(result.Value);
						} else {
							reject(result);
						}
					});
				})

			},
			loadIsNewPayment() {
				api.get("payment/info/HasNewPayment/" + this.Channel._oid, result => {
					if (result.Meta && result.Meta.IsValid && result.Value) {
						this.isNewPayment = _hub.app.isNewPayment = result.Value;
					} else {
						this.isNewPayment = true;
					}
				})
			},
			setResponse(reservation) {
				this.Reservation._Link = JSON.parse(JSON.stringify(reservation._Link));
				this.Reservation._Payment = JSON.parse(JSON.stringify(reservation._Payment));
				this.Reservation._id = reservation._id;
				this.Reservation._uuid = reservation._uuid;
				this.Reservation._Created = reservation._Created;
				this.Reservation._oid = this.Channel._oid;
				this.Reservation.Status = reservation.Status;
				this.Reservation.Channel = reservation.Channel;
			},
			selectPaymentMethod(method) {
				this.Reservation.Payment.Method = method.value;

				if (method.value === "Paypal") this.initPaypal();
				else if (method.value === "Klarna") this.klarna();
			},
			isPaymentMethodSelected(method) {
				return this.Reservation.Payment.Method && this.Reservation.Payment.Method.toLowerCase() == method.toLowerCase();
			},
			log(error, message, type) {
				const data = {
					_oid: this.Channel._oid,
					_uuid: this.Reservation._uuid,
					_RepositoryName: "Entity.Ticketing.Reservation",
					error: `${error}`,
					message: message,
					type: type
				};

				api.post("payment/log", data, result => {});
			},
			async onPostMesssage(data) {
				this.$modals.hide("checkout.credit-card");

				switch (data.action) {
					case "ok":
						EventBus.$emit("loading_start");

						await this.deleteBlockedCapacities();

						var command = `/book/${this.Channel.Directory}`;
						var reservation = this.Reservation.fn.get();

						// the ReferenceID is generated as reference for the payment, use it here as _uuid for the reservation
						if (this.isNewPayment) {
							reservation._Payment.FirstCash = data.data;
						} else {
							reservation._uuid = data.data.ReferenceID;
							reservation.Payment.CreditCard = data.data;
						}

						//
						var saveReservation = (counter) => {
							try {
								if (counter > 3) {
									this.isLoading = false;
									this.validation.errors = [this.T("error_occured_during_booking_try_again_later")];
									this.$modals.show("checkout.validation");
									EventBus.$emit("loading_end");
								} else {
									var result = this.apiPostSynchronously(command, reservation);
									if (result.Meta && result.Meta.IsValid && result.Value.IsValid) {
										this.validation.errors = [];
										this.$router.replace({
											name: "confirmation"
										});
										window.setTimeout(() => {
											EventBus.$emit("checkout_onAfterBook", result.Value);
											EventBus.$emit("loading_end");
										}, 100);
									} else if (result && result.Value && result.Value.Validation && result.Value.Validation.Errors) {
										this.isLoading = false;
										this.validation.errors = result.Value.Validation.Errors;
										this.$modals.show("checkout.validation");
										EventBus.$emit("loading_end");
										saveReservation(counter + 1);
									}
								}
							} catch (e) {
								saveReservation(counter + 1);
							}
						};

						//
						saveReservation(0);

						//
						break;
				}
			}
		},
		mounted() {
			this.loadIsNewPayment();
			this.klarnaLoadScript();

			if (this.hasPaymentMethod("Klarna")) {
				this.klarnaInit({
					...this.Reservation.fn.get(),
					_oid: this.Channel._oid
				}, this.setResponse);
			}
		},
		watch: {
			"Reservation.Payment.Method": {
				handler(newValue, oldValue) {
					if (newValue !== "Klarna") this.klarnaDestroy();
				}
			},
		}
	}